// libraries.
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiAcquisitionsPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import { PolygonObject } from './getPolygons.endpoints';

interface BlockingPolygonsParams {
  country?: string;
  median_zone?: string | number;
}

interface PolygonResponse {
  body: PolygonObject[];
  message: string;
  success: boolean;
}

export const blockingPolygons = apiAcquisitionsPortal.injectEndpoints({
  endpoints: builder => ({
    getBlockingPolygons: builder.query({
      query: ({ country, median_zone }: BlockingPolygonsParams) => {
        const base = `/polygon/blocking?country=${country}`;
        return median_zone ? `${base}&median_zone=${median_zone}` : base;
      },
      transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getBlockingPolygons',
        };
        return modelError;
      },
      transformResponse: (response: PolygonResponse): PolygonObject[] => {
        return response.body;
      },
      providesTags: ['BlockingPolygons'],
    }),
  }),
});

export const { useGetBlockingPolygonsQuery } = blockingPolygons;
